<template>
    <div class="CardDemo">
        <RPCardsLayout class="CardDemo__container">
            <RPSectionHeader>Info Cards</RPSectionHeader>
            <RPInfoCard :title="'Title Only Card'" />
            <RPInfoCard
                :title="'Title Card'"
                :subtitle="'subtitle'"
            />
            <RPInfoCard
                :title="'Title Card'"
                :subtitle="'Subtitle'"
                :info="'This is Infomation.'"
            />
            <RPSectionHeader>Loading</RPSectionHeader>
            <RPInfoCard
                status="loading"
            />

            <RPSectionHeader>Button and Single Field Cards</RPSectionHeader>
            <RPSingleFieldCard
                :title="'Button - Standby'"
            />
            <RPSingleFieldCard
                :title="'Button - Saving'"
                :subtitle="'Subtitle'"
                status="saving"
            />
            <RPSingleFieldCard
                :title="'Button - Success'"
                :subtitle="'Subtitle'"
                status="success"
            />
            <RPSingleFieldCard
                :title="'Button - Success'"
                :subtitle="'Subtitle'"
                status="error"
            />
            <RPSingleFieldCard
                :title="'Dropdown'"
                :subtitle="'Subtitle'"
            >
                <RPDropdown
                    v-model="drop1"
                    :options="dropOptions"
                />
            </RPSingleFieldCard>
            <RPSectionHeader>Form Cards</RPSectionHeader>
            <RPFormCard
                title="Title"
                subtitle="Subtitle"
            />
            <RPSectionHeader>Dynamic Cards</RPSectionHeader>
            <RPDynamicCard
                :cards-data="cardsData"
            >
                <template v-slot="{ card }">
                    {{ card }}
                </template>
            </RPDynamicCard>
        </RPCardsLayout>
    </div>
</template>
<script>
import RPCardsLayout from 'components/Layouts/Common/RPCardsLayout.vue';
import RPDynamicCard from 'components/Complex/Cards/RPDynamicCard.vue';
import RPInfoCard from 'components/Complex/Cards/RPInfoCard.vue';
import RPSectionHeader from 'components/Complex/Cards/RPSectionHeader.vue';
import RPSingleFieldCard from 'components/Complex/Cards/RPSingleFieldCard.vue';
import RPFormCard from 'components/Complex/Cards/RPFormCard.vue';
import RPDropdown from 'components/Basic/FormElements/RPDropdown/RPDropdown.vue';

export default {
    name: 'BaseCardDemo',
    components: {
        RPSectionHeader,
        RPCardsLayout,
        RPInfoCard,
        RPSingleFieldCard,
        RPFormCard,
        RPDynamicCard,
        RPDropdown
    },
    data() {
        return {
            drop1: '',
            dropOptions: [
                {
                    label: "Option 1",
                    value: "opt1",
                    description: 'Metric'
                },
                {
                    label: "Option 2",
                    value: "opt2",
                    description: 'Metric'
                },
                {
                    label: "Option 3",
                    value: "opt3",
                    description: 'Metric'
                },
                {
                    label: "Option 4",
                    value: "opt4",
                    description: 'Metric'
                },        {
                    label: "Option 5",
                    value: "opt5",
                    description: 'Metric'
                }
            ],

            options: [
                {
                    label: "Option 1",
                    value: "opt1",
                    icon: 'home',
                    description: 'Metric'
                },
                {
                    label: "Option 2",
                    value: "opt2",
                    icon: 'home',
                    description: 'Metric'
                },
                {
                    label: "Option 3",
                    value: "opt3",
                    icon: 'home',
                    description: 'Metric'
                },
                {
                    label: "Option 4",
                    value: "opt4",
                    icon: 'home',
                    description: 'Metric'
                },        {
                    label: "Option 5",
                    value: "opt5",
                    icon: 'home',
                    description: 'Metric'
                }
            ],

            cardsData: [
                {
                    "id": "1",
                    "name": "At",
                    "locations_count": 2,
                    "regions_count": 1,
                    "status": 'success',

                },
                {
                    "id": "2",
                    "name": "Modi",
                    "locations_count": 0,
                    "regions_count": 2,
                },
                {
                    "id": "3",
                    "name": "Sed",
                    "locations_count": 3,
                    "regions_count": 1,
                },
            ]
        };
    }
};
</script>
<style lang="scss">
    .CardDemo {
        box-sizing:border-box;
        height: fit-content;
        width: 100%;
        padding: 2rem;
        background: #E5E5E5;
        &__container {
            margin: 1rem auto;
            width: 40rem;
        }
    }
</style>
